import { Link } from 'react-router-dom'

const ErrorPage = () => {
	return (
		<div className="min-h-screen flex items-center justify-center bg-paper text-ink p-4">
			<div className="text-center">
				<h1 className="text-6xl font-bold mb-4">404</h1>
				<p className="text-xl text-ink/60 mb-8">Oops! Page not found.</p>
				<Link to="/" className="text-hazard hover:text-ink transition-colors">
					← Back to Home
				</Link>
			</div>
		</div>
	)
}

export default ErrorPage
